import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Span = styled.span<{ color?: string }>`
  margin-left: 10px;
  color: ${({ color }) => color};
  font-weight: 600;
`
